import { FC, useCallback } from 'react'

import { Navigate, useNavigate, useParams } from 'react-router-dom'

import { useCustomSearchParams } from 'src/Hooks/useCustomSearchParams'
import { SuccessCreatedPreReleaseCampaign } from 'src/Pages/Artist/CreateCampaignPage/AuthPages/PreReleaseTrackDetailsAuth/SuccessCreatedPreReleaseCampaign'
import { campaignsList, scheduleCampaign } from 'src/Router/routes'
import { CampaignStatusEnum } from 'src/Types/campaigns'
import { ScheduleSteps } from 'src/Types/ui'

export const SuccessCreatedFirstPreRelease: FC = () => {
  const navigate = useNavigate()
  const { campaignId } = useParams<{ campaignId: string }>()
  const { search } = useCustomSearchParams()
  const status = search.get('status')

  const onContinue = useCallback((): void => {
    if (status === CampaignStatusEnum.APPROVED) {
      navigate(
        `${campaignsList}${scheduleCampaign}/${campaignId}?step=${ScheduleSteps.SETTINGS}`,
      )
      return
    }

    navigate(campaignsList)
  }, [campaignId, navigate, status])

  if (!campaignId) {
    return <Navigate replace to={campaignsList} />
  }

  return <SuccessCreatedPreReleaseCampaign onContinue={onContinue} />
}
